export const CHART_CONFIG = {
  baseSvgWidth: 550,
  svgHeight: 200,
  visibleCount: 6,
  padding: { top: 15, right: 25, bottom: 30, left: 25 },
  yTicks: [100, 80, 60, 40, 20, 0]
};
